export const THAI_FONT_FAMILY = '"Noto Serif JP", "Kanit", serif';

const thaiButtonStyles = {
  "html[lang^='th'] &": {
    "--thai-font-family": THAI_FONT_FAMILY,
    fontFamily: THAI_FONT_FAMILY,
    fontWeight: 400,
    lineHeight: 1.2,
    padding: "8px",
  },
};

export default thaiButtonStyles;
